module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1b.d764aaa8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-1b.mp3
// module id = 502
// module chunks = 0